export const EXIT_SUBSCRIPTION_MODAL_TEXTS = {
  title: '¿Quieres salir de la suscripción APV?',
  description: 'Puedes suscribir tu APV cuando quieras.',
  stayButton: 'Volver a la suscripción',
  leaveButton: 'Salir',
};

export const EXIT_SUBSCRIPTION_MODAL_WIDTH = 400;
